import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
type Plan = {
  name: string;
  ideal: string;
  was?: string;
  now: string;
  features: string[];
  cta: string;
  featured: boolean;
};
const plans: Plan[] = [{
  name: '📘 MasterPack Marca Propia Argentina™',
  ideal: 'Emprendedores que quieren lanzar su marca de ropa sin perder plata',
  was: '$54.990 ARS',
  now: '$19.990 ARS',
  features: ['12 Tomos completos de indumentaria y marca', 'Sistema de validación antes de comprar stock', 'Calculadora de costos anti-inflación incluida', 'Filtro de proveedores y talleres confiables', 'Hoja de ruta de lanzamiento 21 días', 'Meta Ads Express para indumentaria ARG', '5 Bonos estratégicos gratis', 'Garantía 7 días sin preguntas'],
  cta: 'Quiero mi MasterPack',
  featured: false
}];
const trust = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 minutos'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Precios" className="bg-radial-glow" data-id="element-122" data-mp="9tjuyyr3ipy6">
      <div className="mx-auto max-w-5xl px-5 pt-[18px] pb-[23px]" data-id="element-123" data-mp="erlfzp830zca">
        <div className="mx-auto flex w-full max-w-xl flex-col items-stretch gap-6" data-id="element-124" data-mp="3d8z47xrngvi9">
          {plans.map((plan, i) => <motion.div key={plan.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className={plan.featured ? 'relative flex w-full flex-col items-center rounded-3xl border border-gold/60 bg-ink-2 px-7 pt-10 pb-7 text-center shadow-[0_20px_60px_-20px_rgba(229,185,75,0.45)]' : 'relative flex w-full flex-col items-center rounded-3xl border border-celeste/35 bg-ink-2 px-7 pt-10 pb-7 text-center'} data-id="element-125" data-mp="3i7iqy0e2ibbo" data-mpi={i}>
              {plan.featured && <span className="absolute -top-3 left-1/2 inline-flex -translate-x-1/2 items-center gap-1 rounded-full bg-gold px-4 py-1 text-[11px] font-black uppercase tracking-wide text-ink" data-id="element-126" data-mp="315mn58vszsib">
                  <StarIcon className="h-3 w-3 fill-current" data-id="element-127" data-mp="28h7ed439m6ff" /> Más completo
                </span>}

              <h3 className="font-display text-lg font-black text-white" data-id="element-128" data-mp="23k7fbd4u23xt">{plan.name}</h3>
              <p className="mt-2 text-sm text-white/60" data-id="element-129" data-mp="2ih7wimpeegi1">
                <span className="font-semibold text-white/80" data-id="element-130" data-mp="2dh3f8ugo1hqr">Ideal para:</span> {plan.ideal}
              </p>

              <div className="mt-6" data-id="element-131" data-mp="3tv3es4bln5dh">
                {plan.was && <span className="text-base font-medium text-white/40 line-through" data-id="element-132" data-mp="3txg3d0bv4dzi">
                    {plan.was}
                  </span>}
                <div className="font-display text-4xl font-black text-gold-shine" data-id="element-133" data-mp="9c6ebyxqowj">{plan.now}</div>
                <p className="mt-1 text-xs font-semibold text-celeste" data-id="element-134" data-mp="5ai0ad4c0i7n">
                  Pago único · Acceso de por vida
                </p>
              </div>

              <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-135" data-mp="3rgonkqztj2cg">
                {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-white/80" data-id="element-136" data-mp="j0d7p6nj2wj9">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={3} data-id="element-137" data-mp="nzomia4c3ry7" />
                    {f}
                  </li>)}
              </ul>

              <div className="mt-7 w-full" data-id="element-138" data-mp="a6qlo894h7n9">
                <CTAButton size="md" variant={plan.featured ? 'gold' : 'celeste'} className="w-full" data-id="element-139" data-mp="e93iu89szx8f">
                  {plan.cta}
                </CTAButton>
              </div>

              <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-white/50" data-id="element-140" data-mp="16saiqvj5lkjb">
                {trust.map(({
              icon: Icon,
              label
            }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-141" data-mp="3aaig21c7t1z1">
                    <Icon className="h-4 w-4 text-celeste" data-id="element-142" data-mp="359ulj5os2302" />
                    {label}
                  </span>)}
              </div>
            </motion.div>)}
        </div>

        <div className="mx-auto mt-8 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-celeste/30 bg-celeste/10 p-5 text-left" data-id="element-143" data-mp="1rucrobedtle">
          <ShieldCheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" data-id="element-144" data-mp="3o7ymhcuigvqs" />
          <p className="text-sm leading-relaxed text-white/75" data-id="element-145" data-mp="3o5u6vxn928ao">
            <span className="font-bold text-white" data-id="element-146" data-mp="3k5tra9oezr21">Garantía de devolución de 7 días.</span> Si abrís
            los tomos y en la primera semana sentís que no vale lo que pagaste, pedís el reembolso y
            te devolvemos el 100%. Sin formularios, sin drama, sin vueltas.
          </p>
        </div>
      </div>
    </section>;
}